import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Label, Input, FormFeedback, Form, Nav, NavItem, TabContent, TabPane, CardHeader, NavLink } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import avatar from '../../assets/images/users/user-dummy-img.jpg';
import { establishmentUser, getEstablishmentList, infoUser, passwordUser, updateUser } from '../../slices/thunks';
import { createSelector } from 'reselect';
import 'react-toastify/dist/ReactToastify.css';
import OSelect from '../../Components/OElements/OSelect'; import classnames from "classnames";
import UiContent from '../../Components/Common/UiContent';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const UserProfile = () => {
	const dispatch = useDispatch();
	const [permissionType, setPermissionType] = useState(null);
	const [establishmentList, setEstablishmentList] = useState([]);
	const [establishmentListFiltered, setEstablishmentListFiltered] = useState([]);

	const tabChange = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};

	const selectLayoutState = state => state.Profile;
	const userProfileData = createSelector(selectLayoutState, state => ({
		user: state.user,
	}));
	const { user } = useSelector(userProfileData);

	// const validation = useFormik({
	// 	enableReinitialize: true,
	// 	initialValues: {
	// 		first_name: user?.first_name || '',
	// 		last_name: user?.last_name || '',
	// 		username: user?.username || '',
	// 		email: user?.email || '',
	// 		password: user?.password || '',
	// 		confirm_password: '',  // Nuevo campo de confirmación de contraseña
	// 		id: user?._id || '',
	// 		role: user?.role || '',
	// 		privacy_policy: user?.privacy_policy || false,
	// 		terms_condition: user?.terms_condition || false,
	// 		disabled: user?.disabled || false,
	// 		establishment_active_id: user?.establishment_active_id || null,
	// 		permission_by_establishment_type: user?.permission_by_establishment_type || false,
	// 		permission_by_establishment: user?.permission_by_establishment || false,
	// 		establishment_type_ids: user?.establishment_type_ids || [],
	// 		establishment_ids: user?.establishment_ids || [],
	// 		establishment_default_id: ''
	// 	},
	// 	validationSchema: Yup.object({
	// 		first_name: Yup.string().required('Ingrese su nombre'),
	// 		last_name: Yup.string().required('Ingrese su apellido'),
	// 		password: Yup.string()
	// 			.required('Campo Requerido')
	// 			.min(8, 'La contraseña debe tener al menos 8 caracteres')
	// 			.matches(/[A-Z]/, 'La contraseña debe contener al menos una letra mayúscula')
	// 			.matches(/[a-z]/, 'La contraseña debe contener al menos una letra minúscula')
	// 			.matches(/[0-9]/, 'La contraseña debe contener al menos un número'),
	// 		confirm_password: Yup.string()
	// 			.oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir')
	// 			.required('Confirme su contraseña'),
	// 		establishment_default_id: Yup.string().required('Campo requerido'),
	// 	}),
	// 	onSubmit: values => {
	// 		const updatedUser = {
	// 			username: values.username,
	// 			email: values.email,
	// 			role: values.role,
	// 			first_name: values.first_name,
	// 			last_name: values.last_name,
	// 			full_name: `${values.first_name} ${values.last_name}`,
	// 			privacy_policy: values.privacy_policy,
	// 			terms_condition: values.terms_condition,
	// 			disabled: values.disabled,
	// 			establishment_active_id: values.establishment_active_id,
	// 			permission_by_establishment_type: values.permission_by_establishment_type,
	// 			permission_by_establishment: values.permission_by_establishment,
	// 			establishment_type_ids: values.establishment_type_ids,
	// 			establishment_ids: values.establishment_ids,
	// 			...(values.password === '' ? {} : { password: values.password }),
	// 			establishment_default_id: values.establishment_default_id
	// 		};
	// 		dispatch(updateUser({ username: user.username, user: updatedUser }))
	// 			.then(() => {
	// 				toast.success('Serás redirigido al inicio de sesión en breve.', { autoClose: 3000 });
	// 				setTimeout(() => {
	// 					window.location.href = `${process.env.PUBLIC_URL}/logout`;
	// 				}, 3000);
	// 			});

	// 	},
	// });




	// Formulario para la pestaña "Información"
	const infoFormik = useFormik({
    enableReinitialize: true,
		initialValues: {
			first_name: user?.first_name || '',
			last_name: user?.last_name || '',
			email: user?.email || '',
		},
		validationSchema: Yup.object({
			first_name: Yup.string().required('Ingrese su nombre'),
			last_name: Yup.string().required('Ingrese su apellido'),
			email: Yup.string().email('Correo inválido').required('Ingrese su correo'),
		}),
		onSubmit: (values) => {
			dispatch(infoUser({ username: user.username, user: values }))
				.then(() => {
					toast.success('Información actualizada correctamente');
				})
				.catch(() => toast.error('Hubo un problema al actualizar la información'));
		},
	});


	// Formulario para la pestaña "Contraseña"
	const passwordFormik = useFormik({
    enableReinitialize: true,
		initialValues: {
			password: '',
			confirm_password: '',
		},
		validationSchema: Yup.object({
			password: Yup.string()
				.required('Campo requerido')
				.min(8, 'La contraseña debe tener al menos 8 caracteres')
				.matches(/[A-Z]/, 'Debe contener al menos una letra mayúscula')
				.matches(/[a-z]/, 'Debe contener al menos una letra minúscula')
				.matches(/[0-9]/, 'Debe contener al menos un número'),
			confirm_password: Yup.string()
				.oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir')
				.required('Confirme su contraseña'),
		}),
		onSubmit: (values) => {
			dispatch(passwordUser({ username: user.username, password: values.password }))
				.unwrap()
				.then(() => {
					toast.success('Contraseña actualizada correctamente');
					toast.success('Serás redirigido al inicio de sesión en breve.', { autoClose: 3000 });
					setTimeout(() => {
						window.location.href = `${process.env.PUBLIC_URL}/logout`;
					}, 3000);
				})
				.catch((error) => toast.error(`Error: ${error.message || 'Error al actualizar contraseña.'}`));
		},
	});

	// Formulario para la pestaña "Accesos"
	const accessFormik = useFormik({
    enableReinitialize: true,
		initialValues: {
			establishment_default_id: user?.establishment_default_id || '',
		},
		validationSchema: Yup.object({
			establishment_default_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: (values) => {
			dispatch(establishmentUser({ username: user.username, user: values }))
				.then(() => toast.success('Accesos actualizados correctamente'));
		},
	});


	const loadingEstablishments = async () => {
		try {
			const response = await dispatch(getEstablishmentList({ status_code: 'ACT' })).unwrap();

			const establishments = response.map(establishment => {
				return { value: establishment._id, label: establishment.name, item: establishment }
			});
			setEstablishmentList(establishments);
		} catch (err) {
			console.error('Error al cargar establecimientos:', err);
		}
	}

	// Effect to handle of establishment list filtered by types 
	// when selection of establishment types and permission type changed.
	useEffect(() => {
		if (
			permissionType === 2
		) {
			console.log(
				establishmentList.filter(
					establishmentItem =>
						user.establishment_type_ids
							.includes(establishmentItem.item.establishment_type_id)

				)
			)
			setEstablishmentListFiltered(
				establishmentList.filter(
					establishmentItem =>
						user.establishment_type_ids
							.includes(establishmentItem.item.establishment_type_id)

				)
			)
		}
		if (
			permissionType === 3
		) {
			// console.log(establishmentList.filter(
			// 	establishmentItem =>
			// 		user.establishment_ids
			// 			.includes(establishmentItem.item._id)

			// ))
			setEstablishmentListFiltered(
				establishmentList.filter(
					establishmentItem =>
						user.establishment_ids
							.includes(establishmentItem.item._id)

				)
			)
		}
	}, [
		permissionType,
		establishmentList
	])

	useEffect(() => {
		if (user) {
			setPermissionType(1);
			if (user?.permission_by_establishment_type) {
				setPermissionType(2);
			}
			if (user?.permission_by_establishment) {
				setPermissionType(3);
			}
		}
	}, [user])

	useEffect(() => {
		loadingEstablishments();
	}, []);

	const [activeTab, setActiveTab] = useState("info");
	const toggle = (tab) => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};


	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Perfil' />

					<Row>
						<Col xxl={3}>
							<Card className='h-100'>
								<CardBody className="p-4">
									<div className="text-center">
										<div className="profile-user position-relative d-inline-block mx-auto  mb-4">
											<img src={avatar}
												className="rounded-circle avatar-xl img-thumbnail user-profile-image"
												alt="user-profile" />
											<div className="avatar-xs p-0 rounded-circle profile-photo-edit">
												<Input id="profile-img-file-input" type="file"
													className="profile-img-file-input" />
												<Label htmlFor="profile-img-file-input"
													className="profile-photo-edit avatar-xs">
													<span className="avatar-title rounded-circle bg-light text-body">
														<i className="ri-camera-fill"></i>
													</span>
												</Label>
											</div>
										</div>
										<h5 className="mb-1">
											{user?.full_name ? user.full_name : 'Usuario'}
										</h5>
										<p className="text-muted mb-0">cargo</p>
									</div>
								</CardBody>
							</Card>
						</Col>

						<Col xxl={9}>

							<Card className='h-100'>
								<CardHeader>
									<Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
										<NavItem>
											<NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "info", })} onClick={() => { toggle("info"); }} >
												Información
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "pass", })} onClick={() => { toggle("pass"); }} >
												Contraseña
											</NavLink>
										</NavItem>
										<NavItem>
											<NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "access", })} onClick={() => { toggle("access"); }} >
												Accesos
											</NavLink>
										</NavItem>
									</Nav>

								</CardHeader>
								<CardBody>
									<TabContent activeTab={activeTab} className="text-muted p-0">
										{/* Pestaña "Información" */}
										<TabPane tabId="info" id="production">
											<Form onSubmit={infoFormik.handleSubmit}>
												<Row className='g-3'>
													<h5>Información de Usuario</h5>
													<Col lg={4}>
														<Label className='form-label'>Nombre</Label>
														<Input
															name='first_name'
															className='form-control'
															placeholder='Ingrese su nombre'
															type='text'
															onChange={infoFormik.handleChange}
															onBlur={infoFormik.handleBlur}
															value={infoFormik.values.first_name}
															invalid={infoFormik.touched.first_name && infoFormik.errors.first_name}
														/>
														<FormFeedback>{infoFormik.errors.first_name}</FormFeedback>
													</Col>
													<Col lg={4}>
														<Label className='form-label'>Apellido</Label>
														<Input
															name='last_name'
															className='form-control'
															placeholder='Ingrese su apellido'
															type='text'
															onChange={infoFormik.handleChange}
															onBlur={infoFormik.handleBlur}
															value={infoFormik.values.last_name}
															invalid={infoFormik.touched.last_name && infoFormik.errors.last_name}
														/>
														<FormFeedback>{infoFormik.errors.last_name}</FormFeedback>
													</Col>
													<Col lg={4}>
														<Label className='form-label'>Correo</Label>
														<Input
															name='email'
															className='form-control'
															placeholder='Ingrese su correo'
															type='email'
															onChange={infoFormik.handleChange}
															onBlur={infoFormik.handleBlur}
															value={infoFormik.values.email}
															invalid={infoFormik.touched.email && infoFormik.errors.email}
														/>
														<FormFeedback>{infoFormik.errors.email}</FormFeedback>
													</Col>
													<Col lg={12}>
														<div className="hstack gap-2 justify-content-end">
															<Button color='primary' type='submit'>
																Actualizar Información
															</Button>
														</div>
													</Col>
												</Row>
											</Form>
										</TabPane>

										{/* Pestaña "Contraseña" */}
										<TabPane tabId="pass" id="password">
											<Form onSubmit={passwordFormik.handleSubmit}>
												<Row>
													<Col lg={3}>
														<Label className='form-label'>Contraseña</Label>
														<Input
															name='password'
															className='form-control'
															type='password'
															onChange={passwordFormik.handleChange}
															onBlur={passwordFormik.handleBlur}
															value={passwordFormik.values.password}
															invalid={passwordFormik.touched.password && passwordFormik.errors.password}
														/>
														<FormFeedback>{passwordFormik.errors.password}</FormFeedback>
													</Col>
													<Col lg={3}>
														<Label className='form-label'>Confirmar Contraseña</Label>
														<Input
															name='confirm_password'
															className='form-control'
															type='password'
															onChange={passwordFormik.handleChange}
															onBlur={passwordFormik.handleBlur}
															value={passwordFormik.values.confirm_password}
															invalid={passwordFormik.touched.confirm_password && passwordFormik.errors.confirm_password}
														/>
														<FormFeedback>{passwordFormik.errors.confirm_password}</FormFeedback>
													</Col>
													<Col lg={12}>
														<div className="hstack gap-2 justify-content-end">
															<Button color='primary' type='submit'>
																Actualizar Contraseña
															</Button>
														</div>
													</Col>
												</Row>
											</Form>
										</TabPane>

										{/* Pestaña "Accesos" */}
										<TabPane tabId="access" id="access">
											<Form onSubmit={accessFormik.handleSubmit}>
												<Row className='g-3'>
													<Col lg={3}>
														{/* <OSelect
															label='Establecimiento por Defecto'
															id='establishment_default_id'
															name='establishment_default_id'
															value={accessFormik.values.establishment_default_id}
															onChange={(value) => accessFormik.setFieldValue('establishment_default_id', value)}
															itemsSelect={permissionType === 1 ? establishmentList : establishmentListFiltered}
															validation={accessFormik}
														/> */}

														<OSelect key={`establishment_default_id` + user.establishment_default_id + permissionType + establishmentList + establishmentListFiltered || ''
														}
															label='Establecimiento por Defecto'
															id='establishment_default_id'
															name='establishment_default_id'
															value={accessFormik.values.establishment_default_id || ''}
															itemsSelect={() => {
																if (permissionType == 1) return establishmentList;
																if (permissionType === 2 || permissionType === 3) return establishmentListFiltered;
																return [];
															}}
															validation={accessFormik}
														/>
													</Col>
													<Col lg={12}>
														<div className="hstack gap-2 justify-content-end">
															<Button color='primary' type='submit'>
																Actualizar Acceso
															</Button>
														</div>
													</Col>
												</Row>
											</Form>
										</TabPane>
									</TabContent>
								</CardBody>
							</Card>

						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default UserProfile;
